import React, { useReducer } from "react";
import PropTypes from "prop-types";

import Context from "./context";
import Reducer from "./reducer";
import { SET_LOADING, SET_ERROR, SET_TRIALS } from "./types";

const TrialsState = (props) => {
  const initialState = {
    loading: true,
    error: null,
    trials: [],
    otherTrials: [],
  };
  const init = (initialState) => ({ ...initialState });
  const [state, dispatch] = useReducer(Reducer, initialState, init);

  const getTrials = async () => {
    setLoading();
    const trialsList = await getTrialsList();
    getTrialsFromNCT(trialsList);
  };

  const getTrialsList = async () => {
    setLoading();
    try {
      const res = await fetch(
        `${process.env.GATSBY_STATIC_BASE_URL}/trials/trials.json`,
        { cache: "no-cache" }
      );
      const json = await res.json();
      return json;
    } catch (err) {
      console.error("Error getting resources: ", err);
      dispatch({
        type: SET_ERROR,
        payload:
          "Sorry, there was an issue loading the list of trials. Please try again later.",
      });
    }
  };

  const getTrialsFromNCT = async (trialsList) => {
    // filter out trials without an NCTid
    const trialsString = trialsList
      .map((trial) => trial.nctid)
      .filter((id) => id)
      .join(",");
    const fields = [
      "NCTId",
      "BriefTitle",
      "OverallStatus",
      "StartDate",
      "OverallOfficialAffiliation",
      "LeadSponsorName",
    ];
    const query = `https://clinicaltrials.gov/api/v2/studies?postFilter.ids=${trialsString}&format=json&pageSize=1000&fields=${fields.join(
      ","
    )}`;

    try {
      const res = await fetch(query);
      const json = await res.json();

      const data = json.studies;
      const statuses = [
        "RECRUITING",
        "ACTIVE_NOT_RECRUITING",
        "NOT_YET_RECRUITING",
        "SUSPENDED",
        "WITHDRAWN"
      ];
      data.sort((a, b) => {
        return (
          statuses.indexOf(a.protocolSection.statusModule.overallStatus) -
          statuses.indexOf(b.protocolSection.statusModule.overallStatus)
        );
      });
      const trialsFromNCT = data.map((trial) => {
        const matchedTrial = trialsList.filter(
          (t) => t.nctid == trial.protocolSection.identificationModule.nctId
        )[0];
        const {
          identificationModule,
          contactsLocationsModule,
          sponsorCollaboratorsModule,
          statusModule,
        } = trial.protocolSection;
        return {
          title: identificationModule.briefTitle,
          nctid: identificationModule.nctId,
          dcpid: matchedTrial?.dcpid,
          sponsor:
            matchedTrial?.lao ||
            contactsLocationsModule?.overallOfficials?.affiliation ||
            sponsorCollaboratorsModule?.leadSponsor?.name,

          status: statusModule.overallStatus,
          startDate: statusModule.startDate,
        };
      });
      // Trials in the trialList that do not have an NCTID
      const otherTrials = trialsList
        .filter((trial) => !trial.nctid)
        .map((trial) => ({
          title: trial.title,
          dcpid: trial.dcpid,
          sponsor: trial.lao,
          status: "DCP-Approved",
        }));
      //const trials = [...trialsFromNCT, ...otherTrials];
      dispatch({
        type: SET_TRIALS,
        payload: { trials: trialsFromNCT, otherTrials },
      });
    } catch (err) {
      console.error("Error getting trial information: ", err);
      dispatch({
        type: SET_ERROR,
        payload:
          "Sorry, there was an issue loading trials. Please try again later.",
      });
    }
  };

  const setLoading = async () => dispatch({ type: SET_LOADING });

  return (
    <Context.Provider
      value={{
        loading: state.loading,
        trials: state.trials,
        otherTrials: state.otherTrials,
        error: state.error,
        getTrials,
        ...props.value,
      }}
    >
      {props.children}
    </Context.Provider>
  );
};

TrialsState.propTypes = {
  children: PropTypes.node,
  value: PropTypes.object,
};

export default TrialsState;
